"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const passwordRegex = new RegExp('.{6,}');
exports.default = passwordRegex;
